// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Clock from "@insite/mobius/Icons/Clock";
import Phone from "@insite/mobius/Icons/Phone";
import { locationSearchFormStyles } from "@tps/Overrides/Components/LocationSearchForm";
import IconHeaderLocationInactive from "@tps/XDL/Icons/IconHeaderLocationInactive";
import { color, createLinkIconStyles, hideElement, styledScrollbar, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

locationSearchFormStyles.searchInputGridContainer = {
    gap: 16,
};

locationSearchFormStyles.searchButton = {
    css: css`
        min-height: 36px;
    `,
};

locationSearchFormStyles.searchContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 642px;
    `,
};

locationSearchFormStyles.searchResultRow = {
    css: css`
        ${styledScrollbar(4)}
        padding-right: 5px;
        margin-block: 24px;
        flex: 1;
    `,
};

locationSearchFormStyles.searchResultLocationGridItem = {
    width: [11, 11, 11, 8, 8],
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.locationNameText = {
    color: "primary",
    weight: "bold",
    ellipsis: true,
    size: 16,
    lineHeight: "22px",
};

locationSearchFormStyles.locationNameLink = {
    color: "primary",
    typographyProps: {
        size: 16,
        weight: "bold",
        ellipsis: true,
        css: css`
            &&& {
                line-height: 22px;
            }
        `,
    },
};

locationSearchFormStyles.searchResultPhoneGridItem = {
    width: [10, 10, 10, 10, 11],
};

locationSearchFormStyles.searchResultContentGridItem = {
    width: 3,
    css: css`
        align-items: center;
    `,
};

locationSearchFormStyles.locationContentLink = {
    ...createLinkIconStyles(Clock, {
        typographyProps: { size: 16, weight: "bold" },
        icon: {
            iconProps: {
                size: 15,
            },
        },
    }),
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [11, 11, 11, 3, 3],
    css: css`
        align-items: center;
        &&& {
            margin: 0;
        }
        ${xScreen("gt", "lg")} {
            justify-content: end;
            &&& {
                margin-left: auto;
            }
        }
    `,
};

locationSearchFormStyles.locationGoogleMapsDirectionLink = {
    ...createLinkIconStyles(IconHeaderLocationInactive, {
        typographyProps: { size: 16, weight: "bold" },
        icon: {
            iconProps: {
                size: 15,
            },
        },
    }),
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: 8,
    css: css`
        justify-content: end;
        &&& {
            margin-left: auto;
        }
    `,
};

locationSearchFormStyles.searchResultOffsetGridItem = {
    width: 1,
    css: css`
        max-width: 42px;
        padding-right: 0;
        ${xScreen("gt", "lg")} {
            display: none;
        }
    `,
};

locationSearchFormStyles.searchResultPhoneLink = {
    ...createLinkIconStyles(Phone, {
        typographyProps: { size: 16, weight: "bold" },
        icon: {
            iconProps: {
                size: 15,
            },
        },
    }),
};

locationSearchFormStyles.searchResultDivider = {
    css: css`
        margin: 10px 0;
        border: 1px solid ${color("common.border")};
        width: 100%;
    `,
};

locationSearchFormStyles.searchResultDisplayNumberGridItem = {
    width: 1,
    css: css`
        max-width: 42px;
        padding-right: 0;
    `,
};

locationSearchFormStyles.searchResultAddressInfoOffsetGridItem = {
    width: 1,
    css: css`
        max-width: 42px;
        padding-right: 0;
    `,
};

locationSearchFormStyles.searchResultPhoneOffsetGridItem = {
    width: 1,
    css: css`
        max-width: 42px;
        padding-right: 0;
    `,
};

locationSearchFormStyles.siteMessageGridItem = {
    width: 12,
    css: css`
        &:empty {
            ${hideElement}
        }
    `,
};
